module.exports = window["MaterialUI"].Collapse;